import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Navbar.css';

// 🔗 PLACEHOLDER: Update nav links to match your routes
const NAV_LINKS = [
  { label: 'Home', path: '/' },
  { label: 'About', path: '/about' },
  { label: 'Service', path: '/services' },
  { label: 'Portfolio', path: '/portfolio-work' },
  { label: 'Contact', path: '/contact' },
];

// 🔗 PLACEHOLDER: Replace with your real phone number
const PHONE_NUMBER = '0317 2642218';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  // Close mobile menu when route changes
  useEffect(() => {
    setMobileMenuOpen(false);
  }, [location]);

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  return (
    <nav className={`navbar ${scrolled ? 'navbar--scrolled' : ''}`}>
      <div className="container navbar-inner">
        {/* Logo - using Link for internal navigation */}
        <Link to="/" className="navbar-logo">
          <img src="/images/FG-Logo.png" alt="Faheem Graphics Logo" />
        </Link>

        {/* Desktop Navigation Links */}
        <ul className={`navbar-links ${mobileMenuOpen ? 'active' : ''}`}>
          {NAV_LINKS.map((link) => (
            <li key={link.path}>
              <Link 
                to={link.path}
                className={location.pathname === link.path ? 'active' : ''}
              >
                {link.label}
              </Link>
            </li>
          ))}
        </ul>

        {/* Phone number - keep as regular a tag for tel: links */}
        <a href={`tel:${PHONE_NUMBER}`} className="navbar-phone">
          {PHONE_NUMBER}
        </a>

        {/* Mobile menu toggle */}
        <div 
          className={`navbar-toggle ${mobileMenuOpen ? 'active' : ''}`} 
          onClick={toggleMobileMenu}
          aria-label="Toggle menu"
        >
          <span />
          <span />
          <span />
        </div>
      </div>
    </nav>
  );
}